//workspaceConfigService.js

import workspace from "./workspace";

export const getWorkspaceConfigs = async () => {
  try {
    const response = await workspace.get(`/workspace-config/`);
    return response.data;
  } catch (error) {
    console.error("Error fetching config/s:", error);
    throw error;
  }
};


export const getWorkspaceConfigById = async (id) => {
  try {
    const response = await workspace.get(`/workspace-config/${id}/`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching config/ with ID ${id}:`, error);
    throw error;
  }
};


export const createWorkspaceConfig = async (configData) => {
  try {
    const response = await workspace.post(`/workspace-config/`, configData,{
    });
    return response.data;
  } catch (error) {
    console.error("Error creating config:", error);
    throw error;
  }
};


export const updateWorkspaceConfig = async (id, configData) => {
  try {
    const response = await workspace.put(`/workspace-config/${id}/`, configData, {
    });
    return response.data;
  } catch (error) {
    console.error(`Error updating config with ID ${id}:`, error);
    throw error;
  }
};


export const deleteWorkspaceConfig = async (id) => {
  try {
    const response = await workspace.delete(`/workspace-config/${id}/`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting config with ID ${id}:`, error);
    throw error;
  }
};
